import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Mail, Eye, EyeOff } from 'lucide-react';

export default function EmailQuoteModal({ hub }) {
  const { showEmailQuoteModal, setShowEmailQuoteModal, emailQuoteForm, setEmailQuoteForm, emailSending, handleEmailQuote } = hub;

  return (
    <Dialog open={showEmailQuoteModal} onOpenChange={setShowEmailQuoteModal}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Email Your Quote</DialogTitle>
          <DialogDescription>We'll send your personalized quote to your email address.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="quote-name">Your Name *</Label>
            <Input id="quote-name" value={emailQuoteForm.name} onChange={(e) => setEmailQuoteForm({ ...emailQuoteForm, name: e.target.value })} placeholder="John Doe" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="quote-email">Email Address *</Label>
            <Input id="quote-email" type="email" value={emailQuoteForm.email} onChange={(e) => setEmailQuoteForm({ ...emailQuoteForm, email: e.target.value })} placeholder="john@example.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="quote-phone">Phone (Optional)</Label>
            <Input id="quote-phone" type="tel" value={emailQuoteForm.phone} onChange={(e) => setEmailQuoteForm({ ...emailQuoteForm, phone: e.target.value })} placeholder="(555) 123-4567" />
          </div>
          <div className="border-t pt-4">
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox checked={emailQuoteForm.createAccount} onCheckedChange={(checked) => setEmailQuoteForm({ ...emailQuoteForm, createAccount: checked })} />
              <div><span className="font-medium">Create an account</span><p className="text-sm text-muted-foreground">Save your quotes and book faster next time</p></div>
            </label>
            {emailQuoteForm.createAccount && (
              <div className="mt-4 space-y-2">
                <Label htmlFor="quote-password">Create Password *</Label>
                <div className="relative">
                  <Input id="quote-password" type={emailQuoteForm.showPassword ? 'text' : 'password'} value={emailQuoteForm.password} onChange={(e) => setEmailQuoteForm({ ...emailQuoteForm, password: e.target.value })} placeholder="Enter password" />
                  <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2" onClick={() => setEmailQuoteForm({ ...emailQuoteForm, showPassword: !emailQuoteForm.showPassword })}>
                    {emailQuoteForm.showPassword ? <EyeOff className="h-4 w-4 text-muted-foreground" /> : <Eye className="h-4 w-4 text-muted-foreground" />}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setShowEmailQuoteModal(false)}>Cancel</Button>
          <Button onClick={handleEmailQuote} disabled={emailSending}>{emailSending ? 'Sending...' : <><Mail className="mr-2 h-4 w-4" /> Send Quote</>}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
